// Fora do financeiro-layout.tsx de propósito: as rotas (bundle inicial) leem a
// permissão de cada aba, e importar do layout puxaria o chunk lazy junto.
/** Quem lê a Conciliação (espelha `cobrancaexcecao.GuardLeitura`). */
export const PERMISSOES_CONCILIACAO = ['financeiro:ver', 'financeiro:conciliar'] as const

export interface AbaFinanceiro {
  to: string
  label: string
  requiresPermission: string
  /**
   * Alternativa OR à `requiresPermission`: a aba aparece para quem tiver
   * QUALQUER uma delas. Existe para a Conciliação (FINC-05), que o diretor
   * financeiro — só com `financeiro:conciliar` — precisa alcançar sem ganhar o
   * resto do módulo.
   */
  requiresAnyPermission?: readonly string[]
}

export const ABAS_FINANCEIRO: AbaFinanceiro[] = [
  { to: '/financeiro', label: 'Boletos', requiresPermission: 'financeiro:ver' },
  // AGR-07: o boleto único da cobrança agrupada (lista, rascunhos à espera do lote e a página de cada um).
  { to: '/financeiro/boletos-unicos', label: 'Boletos únicos', requiresPermission: 'financeiro:ver' },
  { to: '/financeiro/plano-contas', label: 'Plano de contas', requiresPermission: 'financeiro:ver' },
  { to: '/financeiro/centros-custo', label: 'Centros de custo', requiresPermission: 'financeiro:ver' },
  { to: '/financeiro/razao', label: 'Razão', requiresPermission: 'financeiro:ver' },
  // F3 (15/10/2026): 'Fornecedores' saiu desta barra para o grupo **Compras**,
  // que é onde quem compra trabalha — mesma direção do 'Ordens de compra' da
  // U3. A rota antiga `/financeiro/fornecedores` segue redirecionando, mas a
  // ABA some: aba que só leva a um redirect nunca fica ativa, e barra com item
  // que nunca acende é ruído.
  //
  // ⚠️ TIRAR DAQUI E TROCAR A ROTA POR REDIRECT É UM SÓ COMMIT, não dois:
  // `permissaoDaAba` LANÇA para aba desconhecida (ver o fim deste arquivo), e
  // `routes/index.tsx` a chamava com '/financeiro/fornecedores'. Separar as
  // duas mudanças derrubaria o app no carregamento do módulo de rotas — não é
  // erro de teste, é exceção em produção.
  //
  // Contas a Pagar (WFC-2) — as demais abas do módulo Financeiro.
  // U3: 'Ordens de compra' saiu daqui para o grupo Compras. A rota antiga
  // segue redirecionando, mas a ABA some — deixá-la apontaria para um
  // redirect, e uma aba que nunca fica ativa é ruído na barra.
  { to: '/financeiro/titulos-pagar', label: 'Títulos a pagar', requiresPermission: 'financeiro:ver' },
  { to: '/financeiro/contratos-recorrentes', label: 'Contratos recorrentes', requiresPermission: 'financeiro:ver' },
  // #232: comissão de parceiros vira título em Contas a Pagar. Gate é
  // comissao:ver, não financeiro:ver — o gestor acompanha a fila sem poder
  // gerar o título, que exige comissao:pagar (crítico + MFA).
  { to: '/financeiro/comissoes', label: 'Comissões de parceiros', requiresPermission: 'comissao:ver' },
  // Contas a Receber (FC-3 "Parte A") — mesmas abas do módulo Financeiro.
  { to: '/financeiro/contas-receber', label: 'Contas a Receber', requiresPermission: 'receber:ver' },
  // Inadimplência — CONFIG GOVERNADA (PR-C3): carência/suspensão/exclusão +
  // gate suspensão→auxílio. Cross-linkada do menu Configurações (Motor de
  // regras). Ver gated receber:ver; editar exige receber:re_rateio + MFA.
  { to: '/financeiro/inadimplencia', label: 'Inadimplência', requiresPermission: 'receber:ver' },
  // FINC-05: exceções de pagamento + conferência diária. A leitura aceita
  // `financeiro:ver` OU `financeiro:conciliar` (o analista que decide precisa
  // ler o que decide); os BOTÕES de decisão são só do `financeiro:conciliar`.
  {
    to: '/financeiro/conciliacao',
    label: 'Conciliação',
    requiresPermission: 'financeiro:ver',
    requiresAnyPermission: PERMISSOES_CONCILIACAO,
  },
]

/** Todas as permissões que abrem a aba (a OR, quando declarada). */
export function permissoesDaAba(to: string): readonly string[] {
  const aba = ABAS_FINANCEIRO.find((a) => a.to === to)
  if (!aba) throw new Error(`aba do financeiro desconhecida: ${to}`)
  return aba.requiresAnyPermission ?? [aba.requiresPermission]
}

export function permissaoDaAba(to: string): string {
  const aba = ABAS_FINANCEIRO.find((a) => a.to === to)
  if (!aba) throw new Error(`aba do financeiro desconhecida: ${to}`)
  return aba.requiresPermission
}
